/**
 * Origins the buy button navigates to. Resolving DNS and completing the TLS
 * handshake while the visitor is still reading removes a full round trip from
 * the jump to checkout.
 *
 * No `crossorigin` attribute on purpose: this is a plain document navigation,
 * not a CORS fetch. Adding it would open a second connection the navigation
 * cannot reuse, defeating the point.
 */
const ORIGINS = ['https://engineer.impultienda.ar', 'https://cdn.shopify.com']

const ATTR = 'data-checkout-preconnect'

function addLinks() {
  const head = document.head || document.documentElement

  ORIGINS.forEach((origin) => {
    const preconnect = document.createElement('link')
    preconnect.rel = 'preconnect'
    preconnect.href = origin
    preconnect.setAttribute(ATTR, '')
    head.appendChild(preconnect)

    // Older Safari ignores preconnect but honours dns-prefetch.
    const prefetch = document.createElement('link')
    prefetch.rel = 'dns-prefetch'
    prefetch.href = origin
    prefetch.setAttribute(ATTR, '')
    head.appendChild(prefetch)
  })
}

let done = false

export function preconnectToCheckout() {
  if (typeof document === 'undefined' || done) return
  done = true
  addLinks()
}

/**
 * Browsers close idle sockets after a few seconds, so a visitor who reads for a
 * minute arrives at the buy button with a cold connection again. Re-issuing the
 * hints on purchase intent means the handshake is warm when it matters.
 */
export function rewarmCheckoutConnection() {
  if (typeof document === 'undefined') return

  document.querySelectorAll(`link[${ATTR}]`).forEach((link) => link.remove())
  addLinks()
}
